import { TaxAccountingType, TaxAccountingTypeExcelImport } from '../../types';

const fixDataTypes = (sheetAsJson: TaxAccountingTypeExcelImport[]): TaxAccountingType[] =>
  sheetAsJson.map(entity => ({
    ...entity,
    plAccount: `${entity.plAccount}`,
    bsAccount: `${entity.bsAccount}`,
    reclassPlAccount: entity.reclassPlAccount ? `${entity.reclassPlAccount}` : '',
    reclassBsAccount: entity.reclassBsAccount ? `${entity.reclassBsAccount}` : '',
    goldId: entity.goldId ? `${entity.goldId}` : '',
  }));

export default fixDataTypes;
